export const ANTD_NEW_THEME = {
  token: {
    colorPrimary: '#084B83',
  },
  components: {
    Button: {
      colorLink: '#084B83',
      colorLinkActive: '#3D87C5',
      colorLinkHover: '#3D87C5',
      defaultShadow: 'none',
      primaryShadow: 'none',
      paddingInline: 16,
      contentFontSizeLG: 14,
    },
    Form: {
      itemMarginBottom: 0,
    },
    Tooltip: {
      colorBgSpotlight: '#1F2C4E',
    },
    Modal: {
      margin: 0,
    },
    Input: {
      fontSizeLG: 13,
      fontSize: 13,
    },
    InputNumber: {
      fontSizeLG: 13,
      fontSize: 13,
    },
    DatePicker: {
      fontSizeLG: 13,
      fontSize: 13,
    },
    Select: {
      fontSizeLG: 13,
      fontSize: 13,
      optionSelectedBg: '#DCE7F2',
      optionSelectedColor: '#084B83',
      colorBorder: '#cad0d5',
    },
    Popconfirm: {
      colorWarning: '#EB3437',
      colorTextHeading: '#EB3437',
    },
    Tabs: {
      colorBorderSecondary: '#dce7f2',
    },
    Collapse: {
      colorBorder: '#dce7f2',
      headerBg: '#fcfcfd',
      colorTextPlaceholder: '#9ca8b2',
    },
  },
}
